import BaseClient from './BaseClient';

class OrgUnitUsersClient extends BaseClient {
    listOrgUnitUsers(teamId, orgUnitId, params) {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}/users`;

        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    countOrgUnitUsers(teamId, orgUnitId, params) {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}/users/count`;

        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    upsertOrgUnitUser(teamId, orgUnitId, userId, data) {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}/users/${userId}`;

        return this.makeCoreApiRequest(url, 'put', data);
    }

    deleteOrgUnitUser(teamId, orgUnitId, userId) {
        const url = `/api/v3/teams/${teamId}/org-units/${orgUnitId}/users/${userId}`;

        return this.makeCoreApiRequest(url, 'delete');
    }
}

export default new OrgUnitUsersClient();
